// TODO: There is a bug with chat while generating consecutive images, breaks interface

import React, { useCallback, useEffect, useRef } from "react";
import {
  Box,
  useColorMode,
  useColorModeValue,
  useDisclosure,
  useBreakpointValue,
  Flex,
} from "@chakra-ui/react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuthStore } from "../stores/authStore";
import { useChatStore } from "../stores/chatStore";
import { aiAPI, systemAPI, userAPI, agentsAPI, chatAPI } from "../services";
import { ChatDrawer } from "./chat/ChatDrawer";
import { ChatNavbar } from "./chat/ChatNavbar";
import { ChatMessages } from "./chat/ChatMessages";
import { ChatInput } from "./chat/ChatInput";
import {
  Agent,
  ChatSessionType,
  GenerateImageDecor8Request,
  IOutputFormat,
  TemplateType,
  TModelSearchResult,
} from "../types";
import { Text } from "@chakra-ui/react";
import i18n from "i18n/config";
import { useInputStore } from "../stores/inputStore";
export const ChatInterface = () => {
  const getRandomNumber = (start: number, end: number) =>
    Math.floor(Math.random() * (end - start + 1)) + start;

  // const handleRandomizeSeed = () => {
  //   setSeed(getRandomNumber(1, Number.MAX_SAFE_INTEGER));
  // };

  const { sessionId } = useParams();
  const navigate = useNavigate();
  const {
    currentSession,
    sessions,
    models,
    selectedModel,
    isLoading,
    error,
    sendMessage,
    sendMultiMessage,
    sendVideoMessage,
    sendPresentationMessage,
    sendImageMessage,
    sendDecor8Message,
    sendDecor8PrimeWallsMessage,
    sendAudioMessage,
    sendAgentMessage,
    loadModels,
    loadSessions,
    createSession,
    deleteSession,
    loadSessionMessages,
    setSelectedModel,
    updateSessionName,
    updateSessionIndexes,
    input,
    promptImage,
    lastPromptImage,
    setPromptImage,
    setLastPromptImage,
    promptImageFile,
    setPromptImageFile,
    setInput,
  } = useChatStore();

  const [editingSessionId, setEditingSessionId] = React.useState<string | null>(
    null
  );
  const [sessionNameInput, setSessionNameInput] = React.useState("");
  const [isExpanded, setIsExpanded] = React.useState(false);
  const [selectedProvider, setSelectedProvider] = React.useState("");
  const [selectedProviders, setSelectedProviders] = React.useState<string[]>([
    selectedProvider || "Groq",
  ]);
  const [selectedModels, setSelectedModels] = React.useState<string[]>([
    selectedModel || "llama-3.3-70b-versatile",
  ]);

  const [credits, setCredits] = React.useState<number>(0);
  const [temperature, setTemperature] = React.useState(0.7);
  const [showTempInput, setShowTempInput] = React.useState(false);
  const [memory, setMemory] = React.useState(10);
  const [showMemoryInput, setShowMemoryInput] = React.useState(false);
  const [showEmbedModelInput, setShowEmbedModelInput] = React.useState(false);
  let initialTemperatures = [0.7, 0.7];
  let initialMemories = [10, 10];
  if (currentSession?.indexes) {
    initialTemperatures = [];
    initialMemories = [];
    for (let i = 0; i < currentSession.indexes; i++) {
      initialTemperatures.push(0.7);
      initialMemories.push(10);
    }
  }
  const [selectedEmbedModel, setSelectedEmbedModel] = React.useState("");
  const [selectedEmbedModels, setSelectedEmbedModels] = React.useState<
    string[]
  >([]);
  const [embedModels, setEmbedModels] = React.useState<any[]>([]);
  const [numSlides, setNumSlides] = React.useState(1);
  const [showNumSlides, setShowNumSlides] = React.useState(false);
  const [slideTemplate, setSlideTemplate] = React.useState("modern");
  const [selectedTemperatures, setSelectedTemperatures] =
    React.useState<number[]>(initialTemperatures);
  const [selectedMemories, setSelectedMemories] =
    React.useState<number[]>(initialMemories);
  const [currencyPairs, setCurrencyPairs] = React.useState<any>({ usd_brl: 7 });
  const [selectedNumChats, setSelectedNumChats] = React.useState(2);
  const [selectedRunwareModel, setSelectedRunwareModel] =
    React.useState<TModelSearchResult | null>(null);
  const [showNegativePrompt, setShowNegativePrompt] = React.useState(false);
  const [negativePrompt, setNegativePrompt] = React.useState("");
  const [isHD, setIsHD] = React.useState(false);
  const [selectedSize, setSelectedSize] = React.useState("Square");
  const [width, setWidth] = React.useState(512);
  const [height, setHeight] = React.useState(512);
  const [format, setFormat] = React.useState<IOutputFormat>("JPEG");
  const [numImages, setNumImages] = React.useState(1);
  const [steps, setSteps] = React.useState(4);
  const [cfgScale, setCfgScale] = React.useState(1);
  const [scheduler, setScheduler] = React.useState(
    "FlowMatchEulerDiscreteScheduler"
  );
  const [seed, setSeed] = React.useState(
    getRandomNumber(1, Number.MAX_SAFE_INTEGER)
  );
  const [strength, setStrength] = React.useState(0.8);
  const [decorType, setDecorType] = React.useState<"prime" | "stage">("prime");
  const [roomType, setRoomType] =
    React.useState<GenerateImageDecor8Request["roomType"]>("bedroom");
  const [designStyle, setDesignStyle] =
    React.useState<GenerateImageDecor8Request["designStyle"]>("modern");
  const [colorScheme, setColorScheme] =
    React.useState<GenerateImageDecor8Request["colorScheme"]>("COLOR_SCHEME_0");
  const [specialityDecor, setSpecialityDecor] =
    React.useState<GenerateImageDecor8Request["specialityDecor"]>(
      "SPECIALITY_DECOR_0"
    );
  const [scaleFactor, setScaleFactor] = React.useState(2);

  const [videoDuration, setVideoDuration] = React.useState<5 | 10>(5);
  const [selectedAgent, setSelectedAgent] = React.useState("");
  const [agents, setAgents] = React.useState<Agent[]>([]);
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const messageColumnRefs = useRef<(HTMLDivElement | null)[]>([]);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const isMobile = useBreakpointValue({ base: true, md: false }) ?? false;

  const { logout } = useAuthStore();
  const { colorMode } = useColorMode();
  // const { isOpen: isDrawerOpen, onOpen: onDrawerOpen, onClose: onDrawerClose } = useDisclosure();
  const {
    isOpen: isModelInfoOpen,
    onOpen: onModelInfoOpen,
    onClose: onModelInfoClose,
  } = useDisclosure();

  const {
    isOpen: isImageModelSettingsOpen,
    onOpen: onImageModelSettingsOpen,
    onClose: onImageModelSettingsClose,
  } = useDisclosure();

  // stores base64 image in state
  const handleSetPromptImage = (promptImage: string) => {
    setPromptImage(promptImage);
  };

  const selectedModelBg = useColorModeValue("gray.50", "gray.700");
  const providerSelectBg = useColorModeValue("gray.100", "gray.700");

  const modelsByProvider = React.useMemo(() => {
    const grouped = models.reduce((acc, model) => {
      if (!acc[model.provider]) {
        acc[model.provider] = [];
      }
      acc[model.provider].push(model);
      return acc;
    }, {} as Record<string, typeof models>);

    if (!selectedProvider && Object.keys(grouped).length > 0) {
      setSelectedProvider(Object.keys(grouped)[0]);
    }

    return grouped;
  }, [models, selectedProvider]);

  const modelsByProviderForChat = React.useMemo(() => {
    const grouped = models
      .filter((m: any) => m.type === "llm" && m.capabilities?.includes("chat"))
      .reduce((acc, model) => {
        if (!acc[model.provider]) {
          acc[model.provider] = [];
        }
        acc[model.provider].push(model);
        return acc;
      }, {} as Record<string, typeof models>);

    // Remove providers with no models
    Object.keys(grouped).forEach((provider) => {
      if (grouped[provider].length === 0) {
        delete grouped[provider];
      }
    });

    return grouped;
  }, [models]);

  const modelsByProviderForImage = React.useMemo(() => {
    const grouped = models
      .filter(
        (m: any) => m.type === "generation" && m.capabilities?.includes("image")
      )
      .reduce((acc, model) => {
        if (!acc[model.provider]) {
          acc[model.provider] = [];
        }
        acc[model.provider].push(model);
        return acc;
      }, {} as Record<string, typeof models>);

    // Remove providers with no models
    Object.keys(grouped).forEach((provider) => {
      if (grouped[provider].length === 0) {
        delete grouped[provider];
      }
    });

    return grouped;
  }, [models]);

  const modelsByProviderForVideo = React.useMemo(() => {
    // console.log("modelsByProviderForVideo", { models });
    const grouped = models
      .filter(
        (m: any) => m.type === "generation" && m.capabilities?.includes("video")
      )
      .reduce((acc, model) => {
        if (!acc[model.provider]) {
          acc[model.provider] = [];
        }
        acc[model.provider].push(model);
        return acc;
      }, {} as Record<string, typeof models>);
    // console.log("grouped", grouped);
    // Remove providers with no models
    Object.keys(grouped).forEach((provider) => {
      if (grouped[provider].length === 0) {
        delete grouped[provider];
      }
    });

    return grouped;
  }, [models]);

  const providersForChat = React.useMemo(
    () => Object.keys(modelsByProviderForChat),
    [modelsByProviderForChat]
  );

  const providersForVideo = React.useMemo(
    () => Object.keys(modelsByProviderForVideo),
    [modelsByProviderForVideo]
  );

  const providersForImage = React.useMemo(
    () => Object.keys(modelsByProviderForImage),
    [modelsByProviderForImage]
  );

  const providers = React.useMemo(
    () => Object.keys(modelsByProvider),
    [modelsByProvider]
  );

  const handleSetSelectedProviders = (providers: string[]) => {
    setSelectedProviders(providers);
    sessionStorage.setItem("selectedProviders", JSON.stringify(providers));
  };

  const handleSetSelectedModels = (models: string[]) => {
    setSelectedModels(models);
    sessionStorage.setItem("selectedModels", JSON.stringify(models));
  };

  const handleSetSelectedTemperatures = (temperatures: number[]) => {
    setSelectedTemperatures(temperatures);
    sessionStorage.setItem(
      "selectedTemperatures",
      JSON.stringify(temperatures)
    );
  };

  const handleSetSelectedMemories = (memories: number[]) => {
    setSelectedMemories(memories);
    sessionStorage.setItem("selectedMemories", JSON.stringify(memories));
  };

  const loadCurrencyPairs = useCallback(async () => {
    const currencyPairs = await systemAPI.getCurrencyPairs();
    setCurrencyPairs(currencyPairs);
  }, []);

  const loadEmbedModels = useCallback(async () => {
    const allModels = await aiAPI.getModels();
    const embedModels = allModels.filter((model) =>
      model.capabilities?.includes("embedding")
    );
    setEmbedModels(embedModels);
  }, []);

  const handleScrollEndMessages = () => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  const loadInitialData = useCallback(() => {
    loadModels();
    loadSessions();
    loadCurrencyPairs();
    loadEmbedModels();
  }, [loadModels, loadSessions, loadCurrencyPairs, loadEmbedModels]);

  useEffect(() => {
    loadInitialData();
  }, [loadInitialData]);

  useEffect(() => {
    if (messagesEndRef.current) {
      setTimeout(() => {
        if (messagesEndRef.current) {
          messagesEndRef.current.scrollIntoView();
        }
      }, 400);
    }
  }, [currentSession?.messages?.length]);

  const loadSession = useCallback(async () => {
    if (sessionId && (!currentSession || currentSession.id !== sessionId)) {
      await loadSessionMessages(sessionId);
    } else if (!sessionId && sessions.length > 0 && !currentSession) {
      navigate(`/chat/${sessions[0].id}`);
    }
    if (window.location.pathname === "/chat" && currentSession) {
      handleSelectSession(currentSession.id);
    }
  }, [sessionId, currentSession, sessions, loadSessionMessages, navigate]);

  useEffect(() => {
    loadSession();
  }, [loadSession]);

  useEffect(() => {
    if (selectedRunwareModel) {
      // autoload img settings from runware model
      setWidth(selectedRunwareModel.defaultWidth);
      setHeight(selectedRunwareModel.defaultHeight);
      setSteps(selectedRunwareModel.defaultSteps);
      setCfgScale(selectedRunwareModel.defaultCFG);
      setScheduler(selectedRunwareModel.defaultScheduler);
    }
  }, [selectedRunwareModel]);

  // load selected providers, models, temperatures and memories from session storage
  useEffect(() => {
    const selectedProviders = sessionStorage.getItem("selectedProviders");
    const selectedModels = sessionStorage.getItem("selectedModels");
    const selectedTemperatures = sessionStorage.getItem("selectedTemperatures");
    const selectedMemories = sessionStorage.getItem("selectedMemories");
    if (selectedProviders) {
      setSelectedProviders(JSON.parse(selectedProviders));
    }
    if (selectedModels) {
      setSelectedModels(JSON.parse(selectedModels));
    }
    if (selectedTemperatures) {
      setSelectedTemperatures(JSON.parse(selectedTemperatures));
    }
    if (selectedMemories) {
      setSelectedMemories(JSON.parse(selectedMemories));
    }
    // Default select based on session type
    // console.log("TEST currentSession", currentSession);
    // if (currentSession?.sessionType === ChatSessionType.VIDEO_CHAT) {
    //   // Only switch if current provider has no video capable models
    //   setSelectedProvider("Runway");
    //   setSelectedModel("runway-video-5s");
    // }

    // if (currentSession?.sessionType === ChatSessionType.STANDARD) {
    //   setSelectedProvider("Groq");
    //   setSelectedModel("llama-3.3-70b-versatile");
    // }
  }, []);

  const handleSend = async () => {
    console.log("handleSend", { input });
    if (!selectedModel.includes("decor8")) {
      if (!input.trim()) return;
    }
    // return;
    try {
      if (currentSession?.sessionType === ChatSessionType.STANDARD) {
        await sendMessage(input, temperature, memory);
      } else if (
        currentSession?.sessionType === ChatSessionType.COMPARATIVE_CHAT
      ) {
        // TODO: There is a bug where some model is apparently selected but passing null
        await sendMultiMessage(
          input,
          selectedModels,
          selectedTemperatures,
          selectedMemories
        );
      } else if (currentSession?.sessionType === ChatSessionType.VIDEO_CHAT) {
        await sendVideoMessage(
          input,
          promptImage,
          lastPromptImage,
          videoDuration
        );
        loadSessionMessages(currentSession?.id);
      } else if (currentSession?.sessionType === ChatSessionType.PRESENTATION) {
        await sendPresentationMessage({
          sessionId: currentSession?.id,
          topic: input,
          numSlides: numSlides,
          model: selectedModel,
          temperature: temperature,
          language: "Português (Brasil)",
          template: slideTemplate as TemplateType,
        });
        loadSessionMessages(currentSession?.id);
      } else if (currentSession?.sessionType === ChatSessionType.IMAGE_CHAT) {
        if (selectedModel.includes("decor8")) {
          if (decorType === "prime") {
            await sendDecor8PrimeWallsMessage({
              sessionId: currentSession?.id,
              imageUrl: promptImage,
            });
          } else if (decorType === "stage") {
            await sendDecor8Message({
              sessionId: currentSession?.id,
              inputImage: promptImage,
              roomType: roomType,
              designStyle: designStyle,
              numImages: numImages,
              keepOriginalDimensions: false,
              colorScheme: colorScheme,
              specialityDecor: specialityDecor,
              scaleFactor: scaleFactor,
            });
          }
        } else if (selectedModel.includes("runware")) {
          await sendImageMessage({
            positivePrompt: input,
            ...(negativePrompt && { negativePrompt }),
            model:
              selectedModel.includes("civitai") && selectedRunwareModel?.air
                ? selectedRunwareModel.air
                : selectedModel,
            seed: seed,
            width: width,
            height: height,
            numberResults: numImages,
            outputFormat: format,
            steps: steps,
            CFGScale: cfgScale,
            scheduler: scheduler,
            outputType: "URL",
            includeCost: true,
            checkNSFW: false,
            ...(promptImageFile && {
              seedImage: promptImageFile,
              strength: strength,
            }),
          });
        }
        loadSessionMessages(currentSession?.id);
      } else if (currentSession?.sessionType === ChatSessionType.AUDIO_CHAT) {
        await sendAudioMessage({
          input: input,
          model: "tts-1-hd",
          voice: "alloy",
        });
        loadSessionMessages(currentSession?.id);
      } else if (currentSession?.sessionType === ChatSessionType.AGENT_CHAT) {
        await sendAgentMessage({
          prompt: input,
          agentId: selectedAgent,
          sessionId: currentSession?.id,
        });
        loadSessionMessages(currentSession?.id);
        // set current session sessionName
      }
      setInput("");
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  const handleLogout = () => {
    logout();
    navigate("/login");
  };
  const findAgentBySessionName = async (sessionId: string) => {
    const sessions = await chatAPI.getSessions();
    const session = sessions.find((s: any) => s.id === sessionId);
    // Extract agent name by removing the UID portion after " - "
    const agentNameSplit = session.sessionName?.split(" - ")[0];
    if (agentNameSplit) {
      const agent = agents.find((a) => a.name === agentNameSplit);
      if (agent) {
        return agent.id;
      }
    }
    return null;
  };
  const handleNewChat = async (
    sessionType: ChatSessionType = ChatSessionType.STANDARD
  ) => {
    const session = await createSession(sessionType);
    if (session) {
      navigate(`/chat/${session.id}`);
    }
    loadSessions();
  };

  const handleSelectSession = async (selectedSessionId: string) => {
    await navigate(`/chat/${selectedSessionId}`);

    // Get the selected session
    const selectedSession = sessions.find((s) => s.id === selectedSessionId);

    if (selectedSession) {
      // Find appropriate provider and model based on session type
      if (selectedSession.sessionType === ChatSessionType.VIDEO_CHAT) {
        const videoProvider = Object.keys(modelsByProviderForVideo)[0];
        if (videoProvider) {
          setSelectedProvider(videoProvider);
          const firstVideoModel =
            modelsByProviderForVideo[videoProvider][0]?.id;
          if (firstVideoModel) {
            setSelectedModel(firstVideoModel);
          }
        }
      } else if (selectedSession.sessionType === ChatSessionType.STANDARD) {
        // Default to a chat provider/model
        const user = await userAPI.getCurrentUser();
        const userLastModel = user.lastModel;
        const chatProvider = Object.keys(modelsByProviderForChat)[0];
        if (chatProvider) {
          setSelectedProvider(chatProvider);
          const firstChatModel = modelsByProviderForChat[chatProvider][0]?.id;
          if (firstChatModel) {
            setSelectedModel(firstChatModel);
          }
        }
        if (userLastModel) {
          setSelectedModel(userLastModel);
          // find and set the provider
          const provider = models.find((m) => m.id === userLastModel)?.provider;
          if (provider) {
            setSelectedProvider(provider);
          }
        }
      } else if (selectedSession.sessionType === ChatSessionType.IMAGE_CHAT) {
        const imageProvider = Object.keys(modelsByProviderForImage)[0];
        if (imageProvider) {
          setSelectedProvider(imageProvider);
          const firstImageModel =
            modelsByProviderForImage[imageProvider][0]?.id;
          if (firstImageModel) {
            setSelectedModel(firstImageModel);
          }

          // if image model, update lastImageModel
          const user = await userAPI.getCurrentUser();
          const userLastImageModel = user.lastImageModel;
          if (userLastImageModel) {
            setSelectedModel(userLastImageModel);
            // find and set the provider
            const provider = models.find(
              (m) => m.id === userLastImageModel
            )?.provider;
            if (provider) {
              setSelectedProvider(provider);
            }
          }
        }
      } else if (selectedSession.sessionType === ChatSessionType.AGENT_CHAT) {
        console.log("TEST selectedSession", { selectedSession });

        const agentId = await findAgentBySessionName(selectedSessionId);
        if (agentId) {
          setSelectedAgent(agentId);
        }
      }
    }

    await loadSessionMessages(selectedSessionId);
  };

  const handleDeleteSession = async (id: string, e: React.MouseEvent) => {
    e.stopPropagation();
    await deleteSession(id);
  };

  const handleStartRename = (
    session: { id: string; sessionName?: string },
    e: React.MouseEvent
  ) => {
    e.stopPropagation();
    setEditingSessionId(session.id);
    setSessionNameInput(session.sessionName || "");
  };

  const handleRename = async (e: React.FormEvent) => {
    e.preventDefault();
    if (editingSessionId && sessionNameInput.trim()) {
      await updateSessionName(editingSessionId, sessionNameInput.trim());
      setEditingSessionId(null);
      setSessionNameInput("");
    }
  };

  const handleSetSelectedAgent = async (selectedAgent: string) => {
    setSelectedAgent(selectedAgent);
    sessionStorage.setItem("selectedAgent", selectedAgent);
    const sessionId = currentSession?.id;
    const messageId = currentSession?.messages[0].id;
    const agent = agents.find((a) => a.id === selectedAgent);
    if (agent && sessionId && messageId) {
      console.log("TEST agent", { agent, sessionId, messageId });
      await chatAPI.updateSystemMessage(
        {
          id: sessionId,
        },
        messageId,
        agent.systemPrompt
      );
      // rename currentSession to agentName
      const sessionIdShort = sessionId.split("-")[0];
      const newSessionName = `${agent.name} - ${sessionIdShort}`;
      await updateSessionName(sessionId, newSessionName);
      loadSessionMessages(sessionId);
    }
  };

  const handleSetSelectedNumChats = (numChats: number) => {
    if (currentSession) {
      if (window.confirm(i18n.t("chat.numChats.warning"))) {
        updateSessionIndexes(currentSession.id, numChats);
      }
    }
  };

  const bg = useColorModeValue("gray.50", "gray.900");
  const borderColor = useColorModeValue("gray.200", "gray.700");

  useEffect(() => {
    const loadUserData = async () => {
      try {
        const userData = await userAPI.getCurrentUser();
        setCredits(Number(userData.credits));
      } catch (error) {
        console.error("Error loading user data:", error);
      }
    };
    const loadAgents = async () => {
      const agents = await agentsAPI.getAgents();
      setAgents(agents.agents);
    };
    loadUserData();
    loadAgents();
    const selectedAgent = sessionStorage.getItem("selectedAgent");
    if (selectedAgent) {
      setSelectedAgent(selectedAgent);
    }
    // if (!isMobile) {
    //   onOpen();
    // }
  }, []);

  const columnWidth = useBreakpointValue({
    base: "100%",
    md:
      (currentSession?.indexes ?? 1) === 1
        ? "100%"
        : (currentSession?.indexes ?? 1) === 2
        ? "50%"
        : (currentSession?.indexes ?? 1) === 3
        ? "33.3333%"
        : "25%",
  });

  useEffect(() => {
    // Sync scroll all columns to bottom
    messageColumnRefs.current.forEach((ref) => {
      if (ref) {
        ref.scrollTop = ref.scrollHeight;
      }
    });
  }, [currentSession?.messages?.length]);

  return (
    <Box h="100vh" display="flex" flexDirection="column">
      <ChatNavbar
        onOpen={onOpen}
        navigate={navigate}
        credits={credits}
        colorMode={colorMode}
        borderColor={borderColor}
      />

      <ChatDrawer
        currentSession={currentSession}
        isOpen={isOpen}
        onClose={onClose}
        sessions={sessions}
        handleNewChat={handleNewChat}
        handleSelectSession={handleSelectSession}
        handleRename={handleRename}
        handleDeleteSession={handleDeleteSession}
        editingSessionId={editingSessionId}
        sessionNameInput={sessionNameInput}
        setSessionNameInput={setSessionNameInput}
        useColorModeValue={useColorModeValue}
        setEditingSessionId={setEditingSessionId}
        handleStartRename={handleStartRename}
      />
      {/* <Text>{JSON.stringify(currentSession)}</Text> */}

      {/* Messages Section */}
      <Box
        flex="1"
        overflowX="auto"
        overflowY="hidden"
        css={{
          "&::-webkit-scrollbar": {
            height: "8px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "rgba(0,0,0,0.2)",
            borderRadius: "4px",
          },
        }}
      >
        <Flex
          h="100%"
          minW={{
            base: "100%",
            md:
              currentSession?.indexes && currentSession.indexes > 1
                ? `${50 * currentSession.indexes}%`
                : "100%",
          }}
          flexWrap="nowrap"
        >
          {currentSession?.indexes ? (
            Array.from({ length: currentSession.indexes }, (_, i) => (
              <Box
                key={i}
                flex="0 0 auto"
                w={columnWidth}
                h="100%"
                borderRight={i < currentSession.indexes - 1 ? "1px" : "0"}
                borderColor={borderColor}
                overflowY="auto"
                ref={(el) => (messageColumnRefs.current[i] = el)}
              >
                <ChatMessages
                  bg={bg}
                  messagesEndRef={messagesEndRef}
                  index={i}
                  sessionId={currentSession?.id}
                />
              </Box>
            ))
          ) : (
            <Box
              flex="1"
              h="100%"
              overflowY="auto"
              ref={(el) => (messageColumnRefs.current[0] = el)}
            >
              <ChatMessages
                bg={bg}
                messagesEndRef={messagesEndRef}
                index={0}
                sessionId={currentSession?.id}
              />
            </Box>
          )}
        </Flex>
      </Box>

      {/* Input Section */}
      <ChatInput
        selectedProvider={selectedProvider}
        setSelectedProvider={setSelectedProvider}
        selectedModel={selectedModel}
        setSelectedModel={setSelectedModel}
        modelsByProvider={modelsByProvider}
        modelsByProviderForChat={modelsByProviderForChat}
        modelsByProviderForVideo={modelsByProviderForVideo}
        modelsByProviderForImage={modelsByProviderForImage}
        isExpanded={isExpanded}
        setIsExpanded={setIsExpanded}
        input={input}
        setInput={setInput}
        borderColor={borderColor}
        providerSelectBg={providerSelectBg}
        onModelInfoOpen={onModelInfoOpen}
        onModelInfoClose={onModelInfoClose}
        isModelInfoOpen={isModelInfoOpen}
        onImageModelSettingsOpen={onImageModelSettingsOpen}
        onImageModelSettingsClose={onImageModelSettingsClose}
        isImageModelSettingsOpen={isImageModelSettingsOpen}
        models={models}
        selectedModelBg={selectedModelBg}
        providers={providers}
        providersForChat={providersForChat}
        providersForVideo={providersForVideo}
        providersForImage={providersForImage}
        handleSend={handleSend}
        isLoading={isLoading}
        error={error || ""}
        temperature={temperature}
        setTemperature={setTemperature}
        showTempInput={showTempInput}
        setShowTempInput={setShowTempInput}
        memory={memory}
        setMemory={setMemory}
        showMemoryInput={showMemoryInput}
        setShowMemoryInput={setShowMemoryInput}
        currencyPairs={currencyPairs}
        currentSession={currentSession}
        setSelectedNumChats={handleSetSelectedNumChats}
        selectedProviders={selectedProviders}
        setSelectedProviders={handleSetSelectedProviders}
        selectedModels={selectedModels}
        setSelectedModels={handleSetSelectedModels}
        selectedTemperatures={selectedTemperatures}
        setSelectedTemperatures={handleSetSelectedTemperatures}
        selectedMemories={selectedMemories}
        setSelectedMemories={handleSetSelectedMemories}
        embedModels={embedModels}
        selectedEmbedModel={selectedEmbedModel}
        setSelectedEmbedModel={setSelectedEmbedModel}
        showEmbedModelInput={showEmbedModelInput}
        setShowEmbedModelInput={setShowEmbedModelInput}
        promptImage={promptImage}
        setPromptImage={setPromptImage}
        lastPromptImage={lastPromptImage}
        setLastPromptImage={setLastPromptImage}
        promptImageFile={promptImageFile}
        setPromptImageFile={setPromptImageFile}
        numSlides={numSlides}
        setNumSlides={setNumSlides}
        showNumSlides={showNumSlides}
        setShowNumSlides={setShowNumSlides}
        slideTemplate={slideTemplate}
        setSlideTemplate={setSlideTemplate}
        showNegativePrompt={showNegativePrompt}
        setShowNegativePrompt={setShowNegativePrompt}
        negativePrompt={negativePrompt}
        setNegativePrompt={setNegativePrompt}
        isHD={isHD}
        setIsHD={setIsHD}
        selectedSize={selectedSize}
        setSelectedSize={setSelectedSize}
        width={width}
        setWidth={setWidth}
        height={height}
        setHeight={setHeight}
        format={format}
        setFormat={setFormat}
        numImages={numImages}
        setNumImages={setNumImages}
        steps={steps}
        setSteps={setSteps}
        cfgScale={cfgScale}
        setCfgScale={setCfgScale}
        scheduler={scheduler}
        setScheduler={setScheduler}
        seed={seed}
        setSeed={setSeed}
        strength={strength}
        setStrength={setStrength}
        decorType={decorType}
        setDecorType={setDecorType}
        roomType={roomType}
        setRoomType={setRoomType}
        designStyle={designStyle}
        setDesignStyle={setDesignStyle}
        colorScheme={colorScheme}
        setColorScheme={setColorScheme}
        specialityDecor={specialityDecor}
        setSpecialityDecor={setSpecialityDecor}
        scaleFactor={scaleFactor}
        setScaleFactor={setScaleFactor}
        selectedRunwareModel={selectedRunwareModel}
        setSelectedRunwareModel={setSelectedRunwareModel}
        isMobile={isMobile}
        handleScrollEndMessages={handleScrollEndMessages}
        videoDuration={videoDuration}
        setVideoDuration={setVideoDuration}
        selectedAgent={selectedAgent}
        setSelectedAgent={handleSetSelectedAgent}
        agents={agents}
      />
    </Box>
  );
};
